import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Unauthenticated = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", p: 2 }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 480, width: "100%", textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          You are not signed in
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please sign in to access this page.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate("/")}>Go to Sign In</Button>
      </Paper>
    </Box>
  );
};

export default Unauthenticated;
